<template>
<!--  <div class="highlight-container">-->
<!--    <div class="buttons" style="margin-bottom: 10px;">-->
<!--&lt;!&ndash;      <el-button type="primary" :disabled="localValue.length >= 10" @click="addInput">添加</el-button>&ndash;&gt;-->
<!--&lt;!&ndash;      <el-button @click="importBatch">批量导入</el-button>&ndash;&gt;-->
<!--&lt;!&ndash;      <el-button type="danger" @click="clearAll">清空</el-button>&ndash;&gt;-->
<!--    </div>-->
<!--    <div v-for="(item, index) in localValue" :key="index" class="input-row">-->
<!--      <el-input-->
<!--        v-model="localValue[index]"-->
<!--        placeholder="6-9个字，空格分隔，回车提交"-->
<!--        style="width: 400px; margin-bottom: 10px;"-->
<!--        @input="emitChange"-->
<!--      />-->
<!--      <el-button-->
<!--        v-if="localValue.length > 1"-->
<!--        type="danger"-->
<!--        icon="el-icon-delete"-->
<!--        circle-->
<!--        @click="removeInput(index)"-->
<!--      />-->
<!--    </div>-->
<!--    <el-dialog title="批量导入" :visible.sync="importVisible" width="500px">-->
<!--      <el-input-->
<!--        v-model="importText"-->
<!--        type="textarea"-->
<!--        placeholder="请输入多个值，用空格或换行分隔"-->
<!--        rows="5"-->
<!--      />-->
<!--      <div slot="footer" class="dialog-footer">-->
<!--        <el-button @click="importVisible = false">取消</el-button>-->
<!--        <el-button type="primary" @click="handleImport">确定导入</el-button>-->
<!--      </div>-->
<!--    </el-dialog>-->
<!--  </div>-->
  <el-select
    v-model="localValue"
    multiple
    filterable
    allow-create
    default-first-option
    placeholder="请输入之后按回车"
    class="custom-tag-select"
    @change="emitChange"
    @paste.native="handlePaste"
  >
    <el-option
      v-for="item in options"
      :key="item.value"
      :label="item.label"
      :value="item.value"
    />
  </el-select>
</template>

<script>
export default {
  name: 'ProductHighlights',
  props: {
    value: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      localValue: null, // 自己管理，不受外部控制
      importVisible: false,
      importText: '',
      options: [
        { value: '请输入', label: '请输入' }
      ]
    }
  },
  mounted() {
    // 初始为空
    this.localValue = this.value.length ? [...this.value] : []
  },
  methods: {
    emitChange() {
      console.log(this.localValue)
      this.$emit('input', this.localValue)
    },
    // emitChange() {
    //   const newValues = []
    //
    //   this.localValue.forEach(val => {
    //     if (typeof val === 'string' && val.includes('\n')) {
    //       const splitValues = val.split(/\n+/).map(s => s.trim()).filter(Boolean)
    //       newValues.push(...splitValues)
    //     } else {
    //       newValues.push(val)
    //     }
    //   })
    //
    //   // 去重 + 限制最多 10 项
    //   const unique = [...new Set(newValues)].slice(0, 10)
    //   this.localValue = unique
    //
    //   this.$emit('input', this.localValue)
    // },
    handlePaste(e) {
      const pasted = e.clipboardData.getData('text')
      const parts = pasted.split(/\n+/).map(s => s.trim()).filter(Boolean)

      const combined = [...this.localValue, ...parts]
      this.localValue = [...new Set(combined)].slice(0, 10)
      this.emitChange()
    },
    addInput() {
      if (this.localValue.length < 10) {
        this.localValue.push('')
      }
    },
    removeInput(index) {
      if (this.localValue.length <= 1) return // 至少保留一个
      this.localValue.splice(index, 1)
      this.emitChange()
    },
    importBatch() {
      this.importText = ''
      this.importVisible = true
    },
    handleImport() {
      const parts = this.importText
        .split(/[\s,，\n]+/)
        .map(s => s.trim())

      if (parts.length === 0) {
        this.importVisible = false
        return
      }

      // 合并并限制最大为10条
      const combined = [...this.localValue, ...parts]
      this.localValue = combined.slice(0, 10)

      this.importVisible = false
      this.emitChange()
    },
    clearAll() {
      this.localValue = ['']
      this.emitChange()
    }
  }
}
</script>

<style scoped>
.input-row {
  display: flex;
  align-items: center;
}
.input-row .el-button {
  margin-left: 10px;
  align-self: flex-start; /* 可选项，如果垂直稍微不齐 */
}
/* 覆盖 el-tag 样式 */
.custom-tag-select ::v-deep .el-tag {
  background-color: white !important;
  color: black !important;
  font-size: 13px;
  margin-top: 0;
  height: 27px !important;
  line-height: 27px !important;
}
.custom-tag-select ::v-deep .el-tag .el-tag__close {
  background-color: transparent !important;
  color: black !important;
  border-radius: 0 !important;
  padding: 0 !important;
  font-weight: bold;
}
</style>
